// "Create a Repair Job" (Service & Repair booking) — same endpoints and params as the Android technician app
// (CreateBookingFragment). Every call resolves to { ok, body, paging, message, activeRecord } and never throws.
import { apiCall } from "./apiCall";

export const bookingCreateApi = {
  // consumer lookup by phone → { full_name, first_name, last_name, email, consumer_id, company_consumer_id, address: { id, display_name } }
  consumerDetail: (phone) => apiCall("get", "consumer/get-detail", { phone }),
  // new consumer: { first_name, last_name, phone, email? } → { consumer: { id (company consumer id), consumer_id, … } }
  storeConsumer: (params) => apiCall("post", "consumer/store", params),

  // consumer addresses (UserLocationResource: id, address_1, address_2, street, city_id, state_id, postal_code, country_name, lat, long)
  addresses: (companyConsumerId) => apiCall("get", "consumer/addresses/list", { company_consumer_id: companyConsumerId }),
  // { company_consumer_id, address_1, street, address_2, city_id, state_id, postal_code, country, lat, long } → full address list
  storeAddress: (params) => apiCall("post", "consumer/addresses/store", params),
  deleteAddress: (id) => apiCall("delete", `consumer/addresses/destroy/${id}`),
  // Google place → address parts (UserLocationResource)
  formattedAddress: (params) => apiCall("get", "formatted/address/get", params),

  // service types for the spinner → [{ id, title, icon }]
  services: () => apiCall("get", "services"),
  // active-job check before creating (job_type "sar") → { count, items: [{ job_type }] }
  validateTechnician: () => apiCall("post", "technicians/validate", { job_type: "sar" }),
  // { consumer_id (company consumer id), address_id, service_id, notes? } → { booking: { id, … } }
  create: (params) => apiCall("post", "consumer/create-booking", params),
};
